module.exports = "<div class=\"tree\"> <ul *ngIf=\"queues && faculty\"> <li *ngFor=\"let queue of queues\"> <qms-queues-tree-view-item [queue]=\"queue\" [parent]=\"parent\" [faculty]=\"faculty\"></qms-queues-tree-view-item> </li> <li *ngIf=\"!parent || parent.category\"> <qms-queues-tree-view-item [parent]=\"parent\" [faculty]=\"faculty\"></qms-queues-tree-view-item> </li> </ul> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/components/management/queues/tree-view/queues-tree-view.component.html
// module id = 282
// module chunks = 0